import React, { useState } from "react";
import { Plus, FilePlus2 } from "lucide-react";
import { Breadcrumb, GradientPanel, SearchInput, EmptyState, PrimaryButton } from "../components/common";

const Extraction = () => {
  const [q, setQ] = useState("");
  return (
    <div>
      <Breadcrumb items={[{ label: "Dashboard", path: "/a/dashboard" }, { label: "Extraction" }]} />
      <GradientPanel>
        <div className="flex items-start justify-between flex-wrap gap-3">
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Extraction</h1>
            <p className="text-sm text-gray-500 mt-1">Manage extraction schemas and document types.</p>
          </div>
        </div>
        <div className="flex items-center justify-between gap-3 mt-5">
          <PrimaryButton icon={Plus}>New</PrimaryButton>
          <SearchInput value={q} onChange={(e) => setQ(e.target.value)} className="w-64" />
        </div>
        <div className="mt-4 border-t border-gray-100">
          <EmptyState
            icon={FilePlus2}
            title="No extractions yet"
            desc="Extraction schemas define which fields to pull from invoices, contracts, and other documents."
            action={<PrimaryButton icon={Plus}>Create extraction</PrimaryButton>}
          />
        </div>
      </GradientPanel>
    </div>
  );
};

export default Extraction;
